<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="session-conflict"
    >
      <div class="session-conflict__backdrop" />
      <div class="session-conflict__card">
        <div class="session-conflict__header">
          <div class="session-conflict__icon-ring">
            <i class="dx-icon-warning" />
          </div>
          <h2 class="session-conflict__title">
            {{ isConflict ? t("sessionConflict.title") : t("sessionConflict.rateLimitTitle") }}
          </h2>
        </div>
        <div class="session-conflict__body">
          <p class="session-conflict__text">
            {{ errorMessage }}
          </p>
        </div>
        <div :class="['session-conflict__actions', { 'session-conflict__actions--end': !isConflict }]">
          <template v-if="isConflict">
            <DxButton
              :text="t('sessionConflict.logout')"
              type="normal"
              styling-mode="outlined"
              :disabled="loading"
              @click="handleLogout"
            />
            <DxButton
              :text="resetButtonText"
              type="danger"
              styling-mode="contained"
              :disabled="loading"
              @click="handleResetSessions"
            />
          </template>
          <DxButton
            :text="t('sessionConflict.retry')"
            type="default"
            styling-mode="contained"
            :disabled="loading"
            @click="handleRetry"
          />
        </div>
        <div
          v-if="emailInfoMessage"
          class="session-conflict__email-info"
        >
          <i class="dx-icon-email" />
          <span>{{ emailInfoMessage }}</span>
        </div>
        <div
          v-if="resetErrorMessage"
          class="session-conflict__reset-error"
        >
          <i class="dx-icon-warning" />
          <span>{{ resetErrorMessage }}</span>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";
import DxButton from "devextreme-vue/button";
import { useSessionConflictStore } from "../store/useSessionConflict";

const { t } = useI18n();

const sessionConflictStore = useSessionConflictStore();
const { handleRetry, handleResetSessions, handleLogout } = sessionConflictStore;
const { visible, loading, mode, errorMessage, emailInfoMessage, resetErrorMessage } =
  storeToRefs(sessionConflictStore);

const isConflict = computed(() => mode.value === "conflict");

const resetButtonText = computed(() =>
  loading.value ? t("sessionConflict.resetting") : t("sessionConflict.resetSessions"),
);
</script>
